import {isExceedingEstimateAllowed} from '../../cache/TimeRegistrationSettingsUtil';

type TimeRegistrationTimeInvalidInput = {
	inputMinutes: number;
	remainingMinutes: number | null;
	/**
	 *  Number of minutes to subtract from the inputMinutes when comparing to remainingMinutes.
	 * Example use-case is to subtract the original minutes when updating a time registration so only any added minutes are compared against the remaining. (In this case, the original minutes will already have been subtracted from the remaining)
	 */
	subtractMinutes?: number;
};
export function isTimeRegistrationTimeInvalid({
	inputMinutes,
	remainingMinutes,
	subtractMinutes = 0,
}: TimeRegistrationTimeInvalidInput): boolean {
	if (isExceedingEstimateAllowed()) return false;
	if (remainingMinutes === null) return false;
	if (inputMinutes < 1) return false;
	return inputMinutes - subtractMinutes > remainingMinutes;
}

type TimeInvalidReasonStringInput = {
	remainingMinutes: number | null;
	subtractMinutes?: number;
};
function getTimeInvalidReasonString({remainingMinutes}: TimeInvalidReasonStringInput): string | null {
	if (remainingMinutes === null) return null;
	return `Time entry cannot exceed the task estimate`;
}

export function isTimeRegistrationTimeInvalidWithReason({
	inputMinutes,
	remainingMinutes,
	subtractMinutes,
}: TimeRegistrationTimeInvalidInput): string | null {
	if (isTimeRegistrationTimeInvalid({inputMinutes, remainingMinutes, subtractMinutes})) {
		return getTimeInvalidReasonString({remainingMinutes, subtractMinutes});
	}

	return null;
}
